<template>
  <editor
    api-key="14w7rph5k02am81sws6r3hy568qta011pppiytoxlusbplv3"
    ref="textEditor"
    :init="{
      height: 350,
      menubar: false,
      plugins: [
        'advlist autolink lists textcolor link image charmap print preview anchor',
        'searchreplace visualblocks code fullscreen',
        'insertdatetime media table paste code help wordcount',
      ],
      toolbar:
        'undo redo | formatselect | bold italic forecolor | \
            alignleft aligncenter alignright alignjustify | \
            bullist numlist outdent indent | removeformat',
    }"
    v-model="content"
  />
</template>

<script>
import Editor from "@tinymce/tinymce-vue";

export default {
  components: {
    editor: Editor,
  },
  props: {
    initialValue: {
      type: String,
      requirde: false,
    },
  },
  created() {
    this.content = this.initialValue
  },
  data() {
    return {
      content: "",
    };
  },
  methods: {},
  watch: {
    content(val) {
      this.$emit("valueChanged", val);
    },
  },
};
</script>

<style lang="scss">
html {
  $border-width: 2px;

  // Light theme
  $border-light: rgb(229 231 235);
  $background-light: rgb(243 244 246);
  $text-light: rgb(75 85 99);

  // Dark theme
  $border-dark: rgb(55 65 81);
  $background-dark: rgb(17 24 39);
  $text-dark: rgb(107 114 128);

  //   Light Theme
  // Text editor base
  .tox {
    border: $border-width solid;
    border-color: $border-light;
    border-radius: 6px;

    // Footer - statusbar
    .tox-statusbar {
      background-color: $background-light;
      border-top: $border-width solid;
      border-color: $border-light;
    }
    // Footer - statusbar - Type of tag
    .tox-statusbar__path-item {
      color: $text-light;
    }
    // Footer - statusbar - Wordcount
    .tox-statusbar__wordcount {
      color: $text-light;
    }
    // Footer - statusbar - Tinymce Title
    .tox-statusbar__branding {
      display: none;
    }
    // Footer - statusbar - Resize Handle
    .tox-statusbar__resize-handle svg {
      fill: $text-light;
    }

    // Header - toolbar
    .tox-toolbar__primary {
      background: none;
      background-color: $background-light;
      border-bottom: $border-width solid;
      border-color: $border-light;
    }
    // Header - toolbar - Buttons Border
    .tox-toolbar__group:not(:last-of-type) {
      border-right: $border-width solid !important;
      border-color: $border-light !important;
    }
    // Header - toolbar - Buttons
    .tox-tbtn {
      color: $text-light;

      svg {
        fill: $text-light;
      }
    }

    // Main - editor
    .tox-edit-area__iframe {
      background-color: $background-light;
    }
  }

  //   Dark Theme
  &.dark {
    // Text editor base
    .tox {
      border-color: $border-dark;

      // Footer - statusbar
      .tox-statusbar {
        align-items: center;
        background-color: $background-dark;
        border-color: $border-dark;
      }
      // Footer - statusbar - Type of tag
      .tox-statusbar__path-item {
        color: $text-dark;
      }
      // Footer - statusbar - Tinymce Title
      .tox-statusbar__wordcount {
        color: $text-dark;
      }
      // Footer - statusbar - Tinymce Title
      .tox-statusbar__resize-handle svg {
        fill: $text-dark;
      }

      // Header - toolbar
      .tox-toolbar__primary {
        background-color: $background-dark;
        border-color: $border-dark;
      }
      // Header - toolbar - Buttons Border
      .tox-toolbar__group:not(:last-of-type) {
        border-color: $border-dark !important;
      }
      // Header - toolbar - Buttons
      .tox-tbtn {
        color: $text-dark;

        svg {
          fill: $text-dark;
        }
      }

      // Main - editor
      .tox-edit-area__iframe {
        background-color: $background-dark;
      }
    }
  }
}
</style>
